import { sendFormData, SendFormData } from 'interfaces/mail.interface';
import { useState, useCallback } from 'react';

interface UseSendFormDataReturn {
    sendFormData: (data: SendFormData) => Promise<void>;
    isLoading: boolean;
    error: string | null;
    isSuccess: boolean;
    data: any;
    reset: () => void;
}

export const useSendFormData = (): UseSendFormDataReturn => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [isSuccess, setIsSuccess] = useState(false);
    const [data, setData] = useState<any>(null);
    
    const reset = useCallback(() => {
        setIsLoading(false);
        setError(null);
        setIsSuccess(false);
        setData(null);
    }, []);
    
    const sendFormDataMutation = useCallback(async (formData: SendFormData) => {
        setIsLoading(true);
        setError(null);
        setIsSuccess(false);
        
        try {
            const result = await sendFormData(formData);
            
            if (result.success) {
                setIsSuccess(true);
                setData(result.data);
            } else {
                setError(result.message || 'Failed to send form data');
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Unknown error');
        } finally {
            setIsLoading(false);
        }
    }, []);
    
    return {
        sendFormData: sendFormDataMutation,
        isLoading,
        error,
        isSuccess,
        data,
        reset,
    };
};
